import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-usersetreminder',
  templateUrl: './usersetreminder.component.html',
  styleUrls: ['./usersetreminder.component.css']
})
export class UsersetreminderComponent implements OnInit {
  subject: any;
  remdate: any;
  type: any;
  userid: any;
  status = 'pending';
  msg: any;
  action: any;
  loading: any;
  constructor( private commonService:CommonService,private snackbar: MatSnackBar) { 
    const udata = this.commonService.getUserDataLocally();
    this.userid = udata.uid;
  }

  ngOnInit() {
    const flag = 0;
    this.commonService.setActivatepath(flag);
  }
  setReminder(){
    if(this.subject == undefined){
      this.msg = "Please Enter suject of reminder";
      this.openSnackBar();
    }
    else if(this.type == undefined){
      this.msg = "Please Select type of reminder";
      this.openSnackBar();
    }
    else if(this.remdate == undefined){
      this.msg = "Please set reminder date";
      this.openSnackBar();
    }
    else {
      this.proceedToSetReminder();
    }
  }
  proceedToSetReminder(){
    this.loading = true;
    this.commonService.setReminderWithUs(this.userid, this.remdate, this.subject, this.type, this.status)
    .subscribe(
      (x) => {
        this.subject = undefined;
        this.remdate = undefined;
        this.type = undefined;
        this.loading = false;
        this.msg = "Reminder set successfully";
        this.openSnackBar();
      }
    );
  }
  openSnackBar() {
    this.snackbar.open(this.msg , this.action, {
      duration: 8000,
    });
  }
}
